import {connect} from "react-redux";

import {connectChangeTrolleyLocationModalAction} from "../../../../utils/trolleys";
import {loadTrolleyLocations} from "../../actions";
import ChangeTrolleyLocationModalContent from "../../../../components/modal/ChangeTrolleyLocationModalContent";


export const ChangeTrolleyLocationModal = connect(
  (state) => ({
    "modal" : state.m.modal,
    "trolley_logs" : state.m.trolley_logs,
    "trolleys": state.support.meta.trolleys,
    "trolley_locations": state.support.trolley_locations.datas,
    "trolley_locations_loading": state.support.trolley_locations.loading,
    "trolley_locations_loaded": state.support.trolley_locations.loaded,
  }),
  (dispatch) => ({
    ...connectChangeTrolleyLocationModalAction(dispatch),
    "loadTrolleyLocations": () => dispatch(loadTrolleyLocations()),
  })
)(ChangeTrolleyLocationModalContent);
